import { React, Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";

import { Link } from "react-router-dom";

import MyGyms from "../../Container/MyGyms/MyGyms";
import Settings from "../../Container/Settings/Settings";
import ErrorBoundary from "../../Container/ErrorBoundery/ErrorBoundery";
import MyTracks from "../../Container/MyTracks/MyTracks";
import JoinGym from "../../Container/JoinGym/JoinGym";
import JoinTrack from "../../Container/JoinTrack/JoinTrack";
import ConnectWithStripeButton from "../../Container/ConnectWithStripeButton/ConnectWithStripeButton";
import SubscribeToPlateform from "../../Container/SubscribeToPlateform/SubscribeToPlateform";

import logo from "../../assets/Images/logo.png";
import menubar from "../../assets/Images/menu.svg";
import tickIcon from "../../assets/Images/tick.svg";
import infoIcon from "../../assets/Images/info.svg";

import { withRouter } from "react-router-dom";

import { callAPI } from "../../assets/Js/backendCommunication";

import {
  clearLocalStorage,
  getIsMessageUnseen,
  getIsNonMessageUnseen,
  removeGym,
  setIsMessageUnseen,
  setIsNonMessageUnseen,
} from "../../assets/Js/localStorage";

import {
  deleteToken,
  getPlainToken,
  getUserData,
} from "../../assets/Js/tokenHandler";

import addGymData from "../../redux/actionCreators/addGymData";
import addUserData from "../../redux/actionCreators/addUserData";
import selectGym from "../../redux/actionCreators/selectGym";

import projectSettings from "../../assets/Js/projectSettings";

import AddTracks from "../../Container/AddTracks/AddTracks";

import avatar from "../../assets/Images/avatar.jpg";

import { getSubscription } from "../../assets/Js/localStorage";

import { getUrlParams } from "../../assets/Js/getUrlParams";
import { getDeviceToken } from "../../assets/Js/firebase";

import GymInformationForm from "../../Container/GymRegistration/GymInformationForm";
import UpdatePayment from "../../Container/UpdatePayment/UpdatePayment";
import { Spinner } from "../../Components/Spinner/Spinner";

import newMessageNotification from "../../redux/actionCreators/newMessageNotification";
import newNonMessageNotifications from "../../redux/actionCreators/newNonMessageNotification";
import { onMessage, isSupported } from "firebase/messaging";

import { messaging } from "../../assets/Js/firebase";
import SaveDeviceToken from "../../ApiHandlers/SaveDeviceToken";

import gotoStripeDashboard from "../../assets/Js/gotoStripeDashboard";

import { immediateToast } from "izitoast-react";
import { findBrowser } from "../../assets/Js/findBrowser";
import browserList from "../../assets/Js/browserList";

import { Notifcation_Not_Supported } from "../../assets/Js/errorMessage";
import DisplayPicture from "../../Components/DisplayPicture/DisplayPicture";
import SubscriptionBar from "../../Components/SubscriptionBar/SubscriptionBar";
import doesUserHasUnreadMessages from "../../ApiHandlers/doesUserHasUnreadMessages";
import NotificationList from "../../Container/NotificationCardList/NotificationCardList";
import Popup from "../../Components/Popup/Popup";

const mapDispatchToProps = (dispatch) => {
  return {
    addUserInfo: (data) => dispatch(addUserData(data)),
    addGymInfo: (data) => dispatch(addGymData(data)),
    selectGym: (data) => dispatch(selectGym(data)),
    newMessageNotification: (data) => dispatch(newMessageNotification(data)),
    newNonMessageNotification: (data) =>
      dispatch(newNonMessageNotifications(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    userUpdated: state.userUpdated,
    trackChanged: state.trackChanged,
    userData: state.userData,
    messageNotification: state.newMessageNotifications,
    newNonMessageNotifications: state.newNonMessageNotifications,
  };
};

let broadcast;

const whichBrowser = findBrowser();

if (
  whichBrowser !== browserList.safari &&
  whichBrowser !== browserList.unknown
) {
  broadcast = new BroadcastChannel("channel1");
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    class NavigationBar extends Component {
      constructor(props) {
        super(props);

        this.state = {
          showProgrammingCalendar: false,
          showManageAthletes: false,
          showMessageScreen: false,
          showAddTrack: false,
          isLoading: false,
          showPersonalSettings: false,
          showGymSettings: false,
          showUpdatePyament: false,
          userData: this.props.userData || "",
          gymData: {},
          notifications: [],
          showErrorScreen: false,
          selectedGymId: null,
          myTracksComp: true,
          notificationPageCount: 1,
          totalNotificationPage: null,
          selectEditTrack: null,
          gymTrack: 1,
          showSubscriptionEnded: null,
          showNotifications: false,
          showWelcomeNote: false,
          welcomeNote: "",
          trackNote: "",
          trialDaysLeft: "",
          showConnectWithStripeAlert: false
        };
      }

      componentDidMount = async () => {
        this.unlisten = this.props.history.listen((location, action) => {
          this.activeNavigationItem();
        });
        this.getGymTrialStatus();
        this.handleShowWelcomeNote = (WelcomeNote, showModel, TrackNote) => {
          this.setState({
            showWelcomeNote: showModel,
            welcomeNote: WelcomeNote,
            trackNote: TrackNote,
          });
        };

        if (getIsMessageUnseen() === "true") {
          this.props.newMessageNotification(true);
        }
        if (getIsNonMessageUnseen() === "true") {
          this.props.newNonMessageNotification(true);
        }

        doesUserHasUnreadMessages(this.hasNewMessageNotification);

        {
          /* Background Notificaiton */
        }
        if (
          whichBrowser !== browserList.safari &&
          whichBrowser !== browserList.unknown
        ) {
          if (broadcast) {
            broadcast.onmessage = (event) => {
              if (event.data === "message") {
                !this.state.showMessageScreen &&
                  this.hasNewMessageNotification();
              } else {
                this.hasNewNonMessageNotificaiton();
              }
            };
          }
        }

        isSupported()
          .then((res) => {
            if (res) {
              getDeviceToken();

              {
                /* Foreground Notificaiton */
              }
              onMessage(messaging, (payload) => {
                if (payload.data.Type === "message") {
                  !this.state.showMessageScreen &&
                    this.hasNewMessageNotification();
                } else {
                  this.hasNewNonMessageNotificaiton();
                }
              });
            } else {
              immediateToast("warning", {
                message: Notifcation_Not_Supported,
              });
            }
          })
          .catch((err) => {
            console.error("Error while chekcing browser support:", err);
          });

        let token = "";
        await this.setState({
          showSubscriptionEnded: getSubscription(),
        });

        this.getGymsData();
        this.activeNavigationItem();

        window.addEventListener("click", this.handleClickOutside, false);
      };

      handleShowConnectWithStripeAlert = (showAlert) => {
        this.setState({ showConnectWithStripeAlert: showAlert });
      };
      componentWillUnmount = () => {
        this.unlisten();
      };

      hasNewMessageNotification = () => {
        this.props.newMessageNotification(true);
        setIsMessageUnseen(true);
      };

      hasNewNonMessageNotificaiton = () => {
        this.props.newNonMessageNotification(true);
        setIsNonMessageUnseen(true);
      };

      handleClickOutside = (event) => {
        if (this.state.showNotifications) {
          const domNode = ReactDOM.findDOMNode(this);

          if (!domNode || !domNode.contains(event.target)) {
            this.setState({
              showNotifications: false,
            });
          }
          this.setState({
            notificationPageCount: 1,
          });
        }
      };

      static getDerivedStateFrom = (props, state) => {
        return {
          ...state,
          trackChanged: props.trackChanged,
          messageNotification: props.messageNotification,
          newNonMessageNotifications: props.newNonMessageNotifications,
        };
      };

      componentDidUpdate(prevProp, prevState) {
        if (
          prevProp.userUpdated !== this.props.userUpdated ||
          prevProp.trackChanged !== this.props.trackChanged
        ) {
          this.getGymsData();
          this.props.addUserInfo(getUserData());
        }
        if (prevProp.userData !== this.props.userData) {
          this.setState({ userData: this.props.userData });
        }
      }

      activeNavigationItem = () => {
        let url = getUrlParams();
        let obj = {
          showProgrammingCalendar: false,
          showManageAthletes: false,
          showMessageScreen: false,
        };
        switch (url) {
          case "/dashboard/programmingcalendar":
            obj.showProgrammingCalendar = true;
            break;
          case "/dashboard/manageathletes":
            obj.showManageAthletes = true;
            break;
          case "/dashboard/messages":
            obj.showMessageScreen = true;
            break;
          default:
            break;
        }
        this.setState(obj);
      };

      getNotifications = async () => {
        this.setState({ isLoading: true });

        let url = `${projectSettings.baseUrl}/notifications/getusernotifications?pageNumber=${this.state.notificationPageCount}`;
        let header = true;
        let type = "GET";
        let data = null;
        let token = getPlainToken();
        let response = "";

        response = await callAPI(url, header, type, data, token);

        if (response) {
          this.setState({ isLoading: false });

          if (response.type === "error") {
          } else if (response.type === "success") {
            this.setState({
              notifications: [
                ...this.state.notifications,
                ...response.data.Notifications,
              ],
              totalNotificationPage: response.data.TotalPages,
            });
            response = "";
          }
        }
      };

      getGymsData = async () => {
        let url = `${projectSettings.baseUrl}/gyms/getusergyms`;
        let header = true;
        let type = "GET";
        let data = null;
        let plainToken = getPlainToken();

        if (plainToken) {
          this.props.setTrackLoader(true);

          let response = await callAPI(
            url,
            header,
            type,
            JSON.stringify(data),
            plainToken
          );
          if (response) {
            this.props.setTrackLoader(false);

            if (response.type === "error") {
              this.setState({ showErrorScreen: true });
            } else if (response.type === "success") {
              await this.setState({ gymData: response.data });
              this.props.selectGym(this.state.gymData[0]);
              this.props.addGymInfo(response.data);
              this.setUserGym(this.state.gymData[0]);

              response = "";
            }
          }
        }
      };

      setUserGym = async (data) => {
        if (this.state.userData?.Role === "owner") {
          await this.setState({
            selectedGymId: data?.Id,
          });
        }
      };

      handleSelectedGym = (gymId) => {
        this.setState({
          selectedGymId: gymId,
          gymTrack: 2,
        });
      };

      editTrackInfo = (value, id) => {
        this.setState({
          myTracksComp: value,
          selectEditTrack: id,
          gymTrack: 3,
        });
      };

      addTrackClicked = () => {
        this.setState({ showAddTrack: true });
      };

      logout = () => {
        removeGym();
        SaveDeviceToken("").then(() => {
          deleteToken();

          window.removeEventListener("click", this.handleClickOutside, false);

          clearLocalStorage();
          window.location.href = "/login";
        });
      };

      forward = () => {
        let value = this.state.gymTrack;

        if (value) {
          this.setState({ gymTrack: value < 4 ? 4 : 5 });
        }
      };

      back = () => {
        let value = this.state.gymTrack;

        let newValue;

        if (value >= 4) {
          value === 4
            ? (newValue = 1)
            : value === 5
              ? (newValue = 4)
              : (newValue = 1);
        }

        if (value) {
          this.setState({ gymTrack: value > 3 ? newValue : --value });
        }
      };

      resetOnCloseModal = () => {
        this.setState({
          gymTrack: 1,
          showAddTrack: false,
          myTracksComp: true,
          showPersonalSettings: false,
          showGymSettings: false,
          showUpdatePyament: false,
        });
      };

      listenToScroll = async (e) => {
        const scrolled =
          e.target.clientHeight + e.target.scrollTop + 10 >
          e.target.scrollHeight;
        if (scrolled) {
          if (
            this.state.totalNotificationPage > this.state.notificationPageCount
          ) {
            this.setState(
              (prevState) => {
                return {
                  notificationPageCount: ++prevState.notificationPageCount,
                };
              },
              () => {
                this.getNotifications();
              }
            );
          }
        }
      };

      notificationImage(image) {
        let newImage = image;
        if (!newImage) {
          newImage = avatar;
        } else {
          newImage = `${projectSettings.baseImageUrl}=${image}`;
        }
        return newImage;
      }

      clickHandlerSubscriptionBar = () => {
        this.setState({
          showProgrammingCalendar: false,
          showManageAthletes: false,
          showMessageScreen: false,
        });
      };

      getGymTrialStatus = async () => {
        let userData = getUserData();
        if (userData && userData.Role === "owner") {
          let url = `${projectSettings.baseUrl}/Gyms/IsOnTrial`;

          let header = true;
          let type = "GET";
          let token = getPlainToken();
          let data = null;
          let response = "";

          response = await callAPI(url, header, type, data, token);

          if (response.data.HasError) {
            immediateToast("warning", { message: "Unable to get the Trial Status of Gym" });
          }
          else {
            let result = response.data.Result;
            this.setState({ trialDaysLeft: result && result.TrialDaysLeft });
          }
        }
      };

      render() {
        return (
          <>
            <div className="container-scroller">
              <nav class="navbar navbar-expand-lg navbar-custom fixed-top">
                <Link
                  className={"navbar-brand"}
                  to={{
                    pathname: "/dashboard",
                  }}
                >
                  <img src={logo} alt="logo" className="navLogo" />
                </Link>

                <div
                  class="collapse navbar-collapse collapse-background"
                  id="navbarText"
                >
                  <ul class="navbar-nav mr-auto ml-3">
                    <li className="nav-item">
                      <Link
                        className={`nav-link ${this.state.showProgrammingCalendar
                          ? "selectedLink"
                          : ""
                          }`}
                        to={{
                          pathname: "/dashboard/programmingcalendar",
                        }}
                      >
                        <i className="mdi mdi-calendar menu-icon mr-2"></i>
                        <span className="menu-title">Programming Calendar</span>
                      </Link>
                    </li>

                    {this.state.userData?.Role === "owner" && (
                      <li className="nav-item">
                        <Link
                          className={`nav-link ${this.state.showManageAthletes ? "selectedLink" : ""
                            }`}
                          to={{
                            pathname: "/dashboard/manageathletes",
                          }}
                        >
                          <i className="mdi mdi-account menu-icon mr-2"></i>
                          <span className="menu-title">Manage Athletes</span>
                        </Link>
                      </li>
                    )}

                    {this.state.userData?.Role === "athlete" && (
                      <li
                        className="nav-item"
                        data-toggle="modal"
                        data-target="#myGyms"
                      >
                        <a className="nav-link" href="#">
                          <i className="mdi mdi-dumbbell menu-icon mr-2"></i>
                          <span className="menu-title">My Gyms</span>
                        </a>
                      </li>
                    )}

                    {this.state.userData?.Role === "owner" && (
                      <li
                        className="nav-item"
                        data-toggle="modal"
                        data-target="#myTracks"
                      >
                        <a className="nav-link" href="#">
                          <i className="mdi mdi-radar menu-icon mr-2"></i>
                          <span className="menu-title">My Tracks</span>
                        </a>
                      </li>
                    )}

                    <li className="nav-item dropdown mr-1">
                      <Link
                        className={`nav-link pointerCursor ${this.state.showMessageScreen ? "selectedLink" : ""
                          }`}
                        to={{
                          pathname: "/dashboard/messages",
                        }}
                      >
                        <span className="count-indicator position-relative">
                          <i className="smallIconFont mdi mdi-message-text-outline mr-2"></i>
                          <span className="menu-title">Messages</span>
                          {this.props.messageNotification && (
                            <span className="messageIndicator"></span>
                          )}
                        </span>
                      </Link>
                    </li>

                    <li className="nav-item navItemMarketplaceLeft">
                      <Link
                        to={{
                          pathname: "/marketplace",
                        }}
                        className="nav-link"
                      >
                        <span className="menu-title">Marketplace</span>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="float-right d-flex right-nav mt-2 align-items-center">
                  <div className="pointerCursor navItemMarketplaceRight secondaryBgColor p-2 rounded">
                    <Link
                      className={
                        "text-white font-weight-bold text-decoration-none"
                      }
                      to={{
                        pathname: "/marketplace",
                      }}
                    >
                      Marketplace
                    </Link>
                  </div>
                  <div>
                    <a
                      className="nav-link notificationIcon count-indicator d-flex align-items-center justify-content-center notification-dropdown position-relative"
                      id="notificationDropdown"
                    >
                      <i
                        className="mdi mdi-bell mx-0 bellIcon"
                        onClick={() => {
                          this.props.newNonMessageNotification(false);
                          setIsNonMessageUnseen(false);

                          this.setState((prevState) => {
                            return {
                              ...prevState,
                              notifications: [],
                              notificationPageCount: 1,
                              showNotifications: !prevState.showNotifications,
                            };
                          });
                          this.getNotifications();
                        }}
                      ></i>
                      {this.props.newNonMessageNotifications && (
                        <span className="notificationIndicator"></span>
                      )}
                    </a>
                    <div
                      onScroll={(e) => {
                        e.preventDefault();
                        this.listenToScroll(e);
                      }}
                      className={`dropdown-menu dropdown-menu-right navbar-dropdown notificationBox secondaryScrollBar ${this.state.showNotifications && "show"
                        }`}
                    >
                      {this.state.notifications.length > 0 ? (
                        <NotificationList
                          notificaitonList={this.state.notifications}
                        />
                      ) : (
                        !this.state.isLoading && (
                          <p className="mb-0 font-weight-normal float-left dropdown-header">
                            No More Notifications
                          </p>
                        )
                      )}
                      {this.state.isLoading && <Spinner />}
                    </div>
                  </div>
                  <div className="mr-2">
                    <a
                      className="nav-link dropdown-toggle navDropDownLink"
                      href="#"
                      data-toggle="dropdown"
                      id="profileDropdown"
                    >
                      <DisplayPicture
                        className="profileLogo"
                        image={this.state.userData?.Image}
                      />
                      <span className="nav-profile-name navProfileName">
                        {this.state.userData?.FirstName}
                      </span>
                    </a>
                    <div
                      className="dropdown-menu dropdown-menu-right navbar-dropdown pt-0 pb-0 shadow mt-1 border"
                      aria-labelledby="profileDropdown"
                    >
                      <a
                        className="dropdown-item dropdownItem pointerCursor"
                        data-toggle="modal"
                        data-target="#gymSetting"
                      >
                        <i className="mdi mdi-settings text-primary mr-2"></i>
                        Settings
                      </a>
                      <hr className="m-0 mx-auto" />
                      <a
                        className="dropdown-item dropdownItem pointerCursor"
                        onClick={this.logout}
                      >
                        <i className="mdi mdi-logout text-primary mr-2"></i>
                        Logout
                      </a>
                    </div>
                  </div>
                  <button
                    class="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarText"
                    aria-controls="navbarText"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <img src={menubar} className="menubar" />
                  </button>
                </div>
              </nav>

              <div className="container-fluid page-body-wrapper minHeight">
                <main className="main-panel dashboardPanel minHeight">
                  {/* Subscription has ended */}
                  {getSubscription() === "true" && (
                    <SubscriptionBar
                      clickHandler={this.clickHandlerSubscriptionBar}
                      trialDaysleft={this.state.trialDaysLeft}
                    />
                  )}
                </main>

                {/* Setting popup */}
                <div
                  className="modal fade"
                  id="gymSetting"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                  data-backdrop="static"
                  data-keyboard="false"
                >
                  <div className="basicFormStyle modal-dialog" role="document">
                    <div className="modal-content border-0 modalRounded1">
                      <div class="modal-header">
                        <button
                          className={`noBgBtn mr-2 ${!this.state.showPersonalSettings &&
                            !this.state.showGymSettings &&
                            !this.state.showUpdatePyament &&
                            "d-none"
                            }`}
                          onClick={() =>
                            this.setState({
                              showPersonalSettings: false,
                              showGymSettings: false,
                              showUpdatePyament: false,
                            })
                          }
                        >
                          <span className="mdi mdi-arrow-left pl-0 ml-0"></span>
                        </button>

                        <h5 class="modal-title">Settings</h5>
                        <button
                          type="button"
                          class="close"
                          data-dismiss="modal"
                          aria-label="Close"
                          onClick={this.resetOnCloseModal}
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <ErrorBoundary>
                          {this.state.userData?.Role === "owner" ? (
                            !this.state.showPersonalSettings &&
                              !this.state.showGymSettings &&
                              !this.state.showUpdatePyament ? (
                              <div className="width-fit-content mx-auto">
                                <div className="mb-3">
                                  <ConnectWithStripeButton redirectToConnectPage={true} modalId="gymSetting" />
                                </div>

                                <div className="mb-3">
                                  <SubscribeToPlateform />
                                </div>

                                <div>
                                  <button
                                    className="basicFatBtnStyle primaryBtn size200-35 mb-3"
                                    onClick={() =>
                                      this.setState({
                                        showPersonalSettings: true,
                                      })
                                    }
                                  >
                                    <i className="mdi mdi-settings mr-2"></i>
                                    Personal Settings
                                  </button>
                                </div>

                                <div>
                                  <button
                                    className="basicFatBtnStyle primaryBtn size200-35 mb-3"
                                    onClick={() =>
                                      this.setState({ showGymSettings: true })
                                    }
                                  >
                                    <i className="mdi mdi-settings mr-2"></i>
                                    Gym Settings
                                  </button>
                                </div>

                                <div>
                                  <button
                                    className="basicFatBtnStyle primaryBtn size200-35 mb-3"
                                    onClick={() => gotoStripeDashboard()}
                                  >
                                    <i className="mdi mdi-settings mr-2"></i>
                                    Stripe Dashboard
                                  </button>
                                </div>

                                <div>
                                  <button
                                    className="basicFatBtnStyle primaryBtn size200-35 mb-3"
                                    onClick={() =>
                                      this.setState({
                                        showUpdatePyament: true,
                                      })
                                    }
                                  >
                                    <i className="mdi mdi-settings mr-2"></i>
                                    Update Payment
                                  </button>
                                </div>
                              </div>
                            ) : (
                              (this.state.showPersonalSettings && (
                                <Settings modalId="gymSetting" />
                              )) ||
                              (this.state.showGymSettings && (
                                <GymInformationForm modalId="gymSetting" />
                              )) ||
                              (this.state.showUpdatePyament && (
                                <UpdatePayment
                                  resetOnCloseModal={this.resetOnCloseModal}
                                  modalId="gymSetting"
                                />
                              ))
                            )
                          ) : (
                            <>
                              {!this.state.showPersonalSettings &&
                                !this.state.showUpdatePyament ? (
                                <div className="width-fit-content mx-auto">
                                  <div>
                                    <div>
                                      <button
                                        className="basicFatBtnStyle primaryBtn size200-35 mb-3"
                                        onClick={() =>
                                          this.setState({
                                            showPersonalSettings: true,
                                          })
                                        }
                                      >
                                        <i className="mdi mdi-settings mr-2"></i>
                                        Personal Settings
                                      </button>
                                    </div>
                                    <div>
                                      <button
                                        className="basicFatBtnStyle primaryBtn size200-35 mb-3"
                                        onClick={() =>
                                          this.setState({
                                            showUpdatePyament: true,
                                          })
                                        }
                                      >
                                        <i className="mdi mdi-settings mr-2"></i>
                                        Update Payment
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                (this.state.showPersonalSettings && (
                                  <Settings modalId="gymSetting" />
                                )) ||
                                (this.state.showUpdatePyament && (
                                  <UpdatePayment
                                    resetOnCloseModal={this.resetOnCloseModal}
                                    modalId="gymSetting"
                                  />
                                ))
                              )}
                            </>
                          )}
                        </ErrorBoundary>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Setting popup ends */}

                {/* My Gyms popup */}
                <div
                  className="modal fade"
                  id="myGyms"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                  data-backdrop="static"
                  data-keyboard="false"
                >
                  <div
                    className="basicFormStyle modal-dialog updateModalDialog"
                    role="document"
                  >
                    <div className="modal-content border-0 modalRounded1">
                      <div class="modal-header">
                        <div className="d-flex">
                          <button
                            className={`noBgBtn mr-2 ${this.state.gymTrack === 1 && "d-none"
                              }`}
                            onClick={this.back}
                          >
                            <span className="mdi mdi-arrow-left pl-0 ml-0"></span>
                          </button>

                          <h5 class="modal-title">
                            {" "}
                            {this.state.gymTrack === 2
                              ? "My Tracks"
                              : this.state.gymTrack === 3
                                ? this.state.selectEditTrack.name
                                : "My Gyms"}
                          </h5>
                        </div>
                        <div>
                          {/* Cross Button to close modal */}
                          <button
                            type="button"
                            className="noBgBtn"
                            data-dismiss="modal"
                            aria-label="Close"
                            onClick={this.resetOnCloseModal}
                          >
                            <span
                              aria-hidden="true"
                              className="mdi mdi-close"
                            ></span>
                          </button>
                        </div>
                      </div>
                      <div className="modal-body">
                        {this.state.gymTrack === 1 ? (
                          <MyGyms
                            modalId={"myGyms"}
                            handleSelectedGym={this.handleSelectedGym}
                            back={this.back}
                            forward={this.forward}
                            resetOnCloseModal={this.resetOnCloseModal}
                          />
                        ) : this.state.gymTrack === 2 ? (
                          <MyTracks
                            modalId={"myGyms"}
                            gymId={this.state.selectedGymId}
                            editTrackInfo={this.editTrackInfo}
                            resetOnCloseModal={this.resetOnCloseModal}
                          />
                        ) : this.state.gymTrack === 3 ? (
                          <AddTracks
                            editableTrack={true}
                            modalId={"myGyms"}
                            handleShowConnectWithStripeAlert={this.handleShowConnectWithStripeAlert}
                            track={this.state.selectEditTrack}
                            updateData={() => {
                              this.setState({
                                myTracksComp: !this.state.myTracksComp,
                                gymTrack: 2,
                              });
                            }}
                            resetOnCloseModal={this.resetOnCloseModal}
                          />
                        ) : this.state.gymTrack === 4 ? (
                          <JoinGym
                            move={this.forward}
                            resetOnCloseModal={this.resetOnCloseModal}
                          />
                        ) : this.state.gymTrack === 5 ? (
                          <JoinTrack
                            modalId="myGyms"
                            showWelcomeNote={this.handleShowWelcomeNote}
                            resetOnCloseModal={this.resetOnCloseModal}
                          />
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                {/* AddTracks Modal */}
                <div
                  className="modal fade"
                  id="addTracks"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                  data-backdrop="static"
                  data-keyboard="false"
                >
                  <div className="basicFormStyle modal-dialog" role="document">
                    <div className="modal-content  modalRounded">
                      <div className="modal-header modalHeader colorWhite">
                        <div className="h3 mr-auto mb-0" id="exampleModalLabel">
                          Add Tracks
                        </div>
                        <div>
                          {/* Cross Button to close modal */}
                          <button
                            type="button"
                            className="noBgBtn"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span
                              aria-hidden="true"
                              className="mdi mdi-close"
                            ></span>
                          </button>
                        </div>
                      </div>
                      <div className="modal-body">
                        <AddTracks
                          modalId="addTracks"
                          editableTrack={false}
                          resetOnCloseModal={this.resetOnCloseModal}
                          handleShowConnectWithStripeAlert={this.handleShowConnectWithStripeAlert}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* AddTracks Modal ends */}
                {/* My Gyms popup end */}

                {/* My Tracks popup */}
                <div
                  className="modal fade"
                  id="myTracks"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                  data-backdrop="static"
                  data-keyboard="false"
                >
                  <div
                    className="basicFormStyle modal-dialog updateModalDialog"
                    role="document"
                  >
                    <div className="modal-content modalContainer border-0 modalRounded">
                      <div class="modal-header">
                        <div className="d-flex">
                          {(!this.state.myTracksComp ||
                            this.state.showAddTrack) && (
                              <button
                                className="noBgBtn mr-2"
                                onClick={() => {
                                  this.setState({
                                    myTracksComp: true,
                                    showAddTrack: false,
                                    gymTrack: 1,
                                  });
                                }}
                              >
                                <i className="mdi mdi-arrow-left"></i>
                              </button>
                            )}
                          <h5 class="modal-title">
                            {!this.state.myTracksComp
                              ? this.state.selectEditTrack.Name
                              : "My Tracks"}
                          </h5>
                        </div>
                        {/* Cross Button to close modal */}
                        <button
                          type="button"
                          className="noBgBtn"
                          data-dismiss="modal"
                          aria-label="Close"
                          onClick={this.resetOnCloseModal}
                        >
                          <span
                            aria-hidden="true"
                            className="mdi mdi-close"
                          ></span>
                        </button>
                      </div>
                      <div className="modal-body tertiaryScrollBar overflow-auto">
                        {this.state.showAddTrack ? (
                          <AddTracks
                            modalId={"myTracks"}
                            resetOnCloseModal={this.resetOnCloseModal}
                            handleShowConnectWithStripeAlert={this.handleShowConnectWithStripeAlert}
                          />
                        ) : this.state.myTracksComp ? (
                          <MyTracks
                            modalId={"myTracks"}
                            gymId={this.state.selectedGymId}
                            editTrackInfo={this.editTrackInfo}
                            addTrackOpened={this.addTrackClicked}
                            resetOnCloseModal={this.resetOnCloseModal}
                          />
                        ) : (
                          <AddTracks
                            editableTrack={true}
                            modalId={"myTracks"}
                            handleShowConnectWithStripeAlert={this.handleShowConnectWithStripeAlert}
                            track={this.state.selectEditTrack}
                            updateData={() => {
                              this.setState({
                                myTracksComp: !this.state.myTracksComp,
                              });
                            }}
                            resetOnCloseModal={this.resetOnCloseModal}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* My Tracks popup end */}
              </div>
              {this.state.showWelcomeNote ? (
                <Popup
                  showModal={this.state.showWelcomeNote}
                  icon={tickIcon}
                  title={
                    <>
                      <span
                        style={{
                          fontSize: "18px",
                          textAlign: "center",
                          marginLeft: "auto",
                        }}
                      >
                        Welcome to
                      </span>
                      <br />
                      <span
                        style={{
                          fontSize: "18px",
                          textAlign: "center",
                        }}
                      >
                        {this.state.trackNote}!
                      </span>
                    </>
                  }
                  children={<p> {this.state.welcomeNote}</p>}
                />
              ) : (
                ""
              )}

              {this.state.showConnectWithStripeAlert ? (
                <Popup
                  showModal={this.state.showConnectWithStripeAlert}
                  icon={infoIcon}
                  title={
                    <>
                      <span
                        style={{
                          fontSize: "18px",
                          textAlign: "center",
                          marginLeft: "auto",
                        }}
                      >
                        Before creating a paid track you must first connect to a Stripe account
                      </span>
                    </>
                  }
                  children={<ConnectWithStripeButton redirectToConnectPage={true} modalId={"messageModal"} />}
                />
              ) : (
                ""
              )}
            </div>
          </>
        );
      }
    }
  )
);
